import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { Icon, IconSize } from 'app/design-system/components/Icon';
import type { IconName } from 'app/design-system/types/Icon';

import DropdownMenuItem from './DropdownMenuItem';

import styles from './DropdownMenu.module.scss';

export type MenuLinkProps = {
  to: string;
  icon?: IconName;
  label: string;
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  'data-test'?: string;
  'data-ga-event'?: string;
  'data-ga-event-value'?: string;
};

const LinkMenuItem: FC<MenuLinkProps> = ({
  disabled,
  to,
  icon,
  className,
  label,
  onClick,
  ...props
}) => {
  const content = [
    <span key="label"
          className={styles.label}>
      {icon && (
        <Icon icon={icon}
              size={IconSize.MEDIUM}
              className={styles.linkIcon} />
      )}
      {label}
    </span>,
  ];

  return (
    <DropdownMenuItem disabled={disabled}
                      onClick={onClick}
                      className={className}
                      data-test={props['data-test']}>
      {disabled
        ? <span>{content}</span>
        : (
          <Link
            to={to}
            data-ga-event={props['data-ga-event']}
            data-ga-event-value={props['data-ga-event-value']}>
            {content}
          </Link>
        )}
    </DropdownMenuItem>
  );
};

export default LinkMenuItem;
